import { createStyles, makeStyles } from '@material-ui/core';
import { SelectableCardProps } from 'components/UI/V2/Forms/SelectableCard/SelectableCard';

export const useSelectableCardStyles = makeStyles(() =>
    createStyles({
        root: {
            width: '100%',
            userSelect: 'none'
        },
        card: (props: SelectableCardProps) => ({
            gap: 10,
            width: '100%',
            display: 'flex',
            borderRadius: 12,
            borderStyle: 'solid',
            position: 'relative',
            cursor: 'pointer',

            margin: props.checked ? '-1px' : '0px',
            borderWidth: props.checked ? '2px' : '1px',
            borderColor: props.checked ? '#000' : '#D3D3D3',
            padding: props.checked ? '16px 19px 16px 20px' : '16px 20px'
        }),
        iconContainer: {
            'width': 20,
            'flexShrink': 0,

            '& > *': {
                width: '100%',
                fontSize: 20
            }
        },
        label: {
            fontSize: 16,
            lineHeight: 1,
            fontWeight: 600,
            display: 'block',
            color: '#000',
            marginBottom: 4
        },
        description: {
            margin: 0,
            fontSize: 14,
            lineHeight: 1.4,
            color: '#7A7A7A'
        },
        radioContainer: {
            marginLeft: 'auto'
        },
        radio: (props: SelectableCardProps) => ({
            'margin': 0,
            'width': 20,
            'height': 20,
            'display': 'flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            'borderRadius': '50%',
            'pointerEvents': 'none',
            'borderStyle': 'solid',
            'borderWidth': props.checked ? 0 : 2,
            'borderColor': props.checked ? '#000' : '#E5E5E5',

            '& > svg': {
                fontSize: 20,
                color: '#5E8677',

                display: props.checked ? 'block' : 'none'
            }
        })
    })
);
